// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"356":"jobstructure","765":"newproject"}[chunkId] + "." + {"356":"66f526b2","765":"8914d07a"}[chunkId] + ".css";
};